/**
 * spinner.js
 */

import React from "react";
import { useTheme } from '@mui/material/styles';

export default function Spinner(props) {
  const { size } = props;
  const theme = useTheme();
  
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      //xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={size || '40px'}
      height={size || '40px'}
      viewBox="0 0 50 50"
      className={`${props.className || ''} pt-spinner`}
      // xml:space="preserve"
      data-testid="loading-spinner"
    >
      <path
        fill={props && props.fill ? props.fill : theme.palette.primary.colors[4]}
        d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="750ms"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
}
